
<router-outlet></router-outlet>

<tacho-alert></tacho-alert>

<tacho-full-page-loader [show]="showLoader"></tacho-full-page-loader>

